module.exports = __webpack_public_path__ + "img/logo9.a5e955b8.png";